<div class="bg-brown-500 bg-cover center-all minimal-height  bg-center" style="background-image: url('bg.jpg?v=1')">
  <div class="container">
    <app-search-widget></app-search-widget>
  </div>
</div>
